var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmailIconMaroon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_194_2476)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1004 4.28171L16.4469 3.59998L10.3934 9.91493C9.6367 10.7043 8.36409 10.7043 7.6074 9.91493L1.55389 3.63586L0.900391 4.31758L5.40612 9.01792L0.900391 13.7183L1.55389 14.4L6.05963 9.69964L6.95389 10.6325C7.50421 11.2066 8.22651 11.5295 8.98319 11.5295C9.73988 11.5295 10.4622 11.2066 11.0125 10.6325L11.9068 9.69964L16.4125 14.4L17.066 13.7183L12.5603 9.01792L17.1004 4.28171Z",
    fill: "#DC4E4E",
    stroke: "#DC4E4E",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4474 15.9157H1.58076C0.715105 15.9157 0 15.2006 0 14.335V3.72132C0 2.85567 0.715105 2.14056 1.58076 2.14056H16.4474C17.313 2.14056 18.0281 2.85567 18.0281 3.72132V14.335C18.0281 15.2006 17.313 15.9157 16.4474 15.9157ZM1.54312 3.15676C1.24202 3.15676 1.0162 3.38258 1.0162 3.68368V14.2973C1.0162 14.5984 1.24202 14.8242 1.54312 14.8242H16.4097C16.7108 14.8242 16.9367 14.5984 16.9367 14.2973V3.68368C16.9367 3.38258 16.7108 3.15676 16.4097 3.15676H1.54312Z",
    fill: "#DC4E4E",
    stroke: "#DC4E4E",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_194_2476"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIconMaroon);
export default __webpack_public_path__ + "static/media/email-icon-maroon.63fabc017866bc3deeda605e9a465738.svg";
export { ForwardRef as ReactComponent };